import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';

import { BillingInfo } from '../models/billing-body.model';
import { BillingRepository } from '../repositories/billing.repository';

export class StoreBillingDataUseCase implements UseCase<BillingInfo, boolean> {
    constructor(private readonly repository: BillingRepository) {}

    execute(billingData: BillingInfo): Observable<boolean> {
        return this.repository.storeBilling(billingData);
    }
}
